const headerProductUrls = {
  P001: '/uk-recordkeeping-dashboard',
  P002: '/uk-communication-records',
  P003: '/regulatory-reference-data',
  P004: '/eu-recordkeeping-dashboard',
  P005: '/eu-communication-records',
  reference_data: '/reference-data',
  settings: '/settings',
  filestorage: '/file-storage',
};

export default headerProductUrls;


// reg_id,Regulation_Name
// R001,RTS 24
// R002,ANNEX IV Orders
// R003,ANNEX IV Executions
// R004,RTS 22
// R005,UK FIRDS
// R006,EU FIRDS
// R007,UPI
// R008,GLIEF
// product_id,Product_Name
// P001, UK MIFID II Record Keeping
// P002,UK Communicatios Record
// P003,Regulatory Reference Data
// P004,EU MIFID II Record Keeping
// P005,EU Communicatios Record
